





































































































































import { MemberManagementMemberAddressService as memberAddressApi } from "@/common/api";
import QErrors from "@/common/qErrors.vue";
import QNotify from "@/common/qNotify";
import { compareWithKeys } from "@/common/utils";
import PostalCode from "@/components/common/postalCode.vue";
import _isEmpty from "lodash/isEmpty";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "MemberAddressEditComponent",
  components: {
    QErrors,
    PostalCode,
  },
})
export default class MemberAddressEditComponent extends Vue {
  public errorStyle = {
    width: "inherit",
  };

  public isShow = false;
  public isEdit = false;
  public errors = {};
  public memberId = null;
  public memberAddress: any = {
    id: null,
    name: null,
    zip: null,
    address1: null,
    address2: null,
    address3: null,
    tel: null,
  };

  public memberAddressInit: any = {};

  public show(memberId, memberAddress: any = {}) {
    this.initComponent();
    if (!_isEmpty(memberAddress)) {
      this.isEdit = true;
      const {
        id,
        name,
        zip,
        address1,
        address2,
        address3,
        tel,
      } = memberAddress;
      this.memberAddress = {
        id,
        name,
        zip,
        address1,
        address2,
        address3,
        tel,
      };
    }
    this.memberAddressInit = JSON.parse(JSON.stringify(this.memberAddress));
    this.memberId = memberId;
    this.isShow = true;
  }

  public initComponent() {
    this.isEdit = false;
    this.errors = {};
    (this.$refs.postalCode as PostalCode).isNotFound = false;
    this.memberAddress = {
      id: null,
      name: null,
      zip: null,
      address1: null,
      address2: null,
      address3: null,
      tel: null,
    };
  }

  public onChangePostalCode(address) {
    this.memberAddress.address1 = address.pref_name + address.city_name;
    this.changeInput("address1");
  }

  public clearAddress() {
    this.memberAddress.address1 = null;
    this.memberAddress.address2 = null;
    this.memberAddress.address3 = null;
  }

  public changeInput(key) {
    this.errors = { ...this.errors, ...{ [key]: [] } };
  }

  public confirmDelete() {
    this.$modal.showDelete({
      text: `${this.$t("common.message.delete_confirm")}`,
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        let message: any;
        try {
          const response = await memberAddressApi.adminMemberAddressDelete({
            id: this.memberAddress.id,
          });

          message = response.message;
          QNotify.success({
            text: message,
          });
          this.close();
        } catch (error) {
          message = error.body.message;
          QNotify.error({
            text: message,
          });
        }
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  public cancel() {
    // check modifier form.
    const diff = compareWithKeys(
      this.memberAddress,
      this.memberAddressInit,
      ["name", "zip", "address1", "address2", "address3", "tel"],
      true,
    );

    if (!diff) {
      this.$modal.showCancel({
        text: `${this.$t("common.message.cancel_confirm")}`,
        onConfirm: () => {
          this.close();
        },
      });
    } else {
      this.close();
    }
  }

  public close() {
    this.isShow = false;
    this.$emit("close");
  }

  public async submit() {
    let result;
    try {
      result = this.memberAddress.id
        ? await memberAddressApi.adminMemberAddressEdit({
          ...this.memberAddress,
          ...{
            id: this.memberAddress.id,
            memberId: this.memberId,
          },
        })
        : await memberAddressApi.adminMemberAddressCreate({
          ...this.memberAddress,
          ...{
            memberId: this.memberId,
          },
        });

      QNotify.success({
        text: this.memberAddress.id
          ? this.$t("common.message.updated")
          : this.$t("common.message.created"),
      });
      this.close();
    } catch (error: any) {
      result = error.body;
      QNotify.error({
        text: result.message,
      });
      this.errors = result.errors;
    }
  }
}
